import { get } from 'lodash'
import axios from 'axios'

const baseURL = '/api/image'

export default class Image {
	constructor (init = {}) {
		// eslint-disable-next-line
		this.id = get(init, 'id') ? init.id : null
		this.name = get(init, 'name') ? init.name : ''
		this.original = get(init, 'original') ? init.original : ''
		this.small = get(init, 'small') ? init.small : ''
		this.medium = get(init, 'medium') ? init.medium : ''
		this.check = false
	}

	get smaller () {
		return this.small || this.medium || this.original
	}

	async delete () {
		try {
			const res = await axios.delete(baseURL, {
				params: {
					id: [this.id]
				}
			})
			return res
		} catch (e) {
			console.error(e)
			return false
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/ImageManager/Image.js